import React from 'react';
import './LoadingCard.css';

const LoadingCard = ({ isExiting }) => {
  return (
    <div className={`loading-card ${isExiting ? 'exiting' : ''}`}>
      <div className="loading-card-ripple">
        <img 
          src="/ripple-horiz.svg" 
          alt="Loading animation"
          className="loading-card-ripple-svg"
        />
      </div>
      <div className="loading-card-content">
        <h2 className="loading-title">Curating The Digital Archive</h2>
        <p className="loading-subtitle">Weaving together thoughts, discoveries, and insights...</p>
      </div>
    </div>
  );
};

export default LoadingCard;